import { useQuery } from '@tanstack/react-query';
import { type DefaultSampleDetail } from 'data/v3/data-contracts';
import {
  request,
  type V3ApiError,
  type V3ApiSuccessData,
} from 'javascripts/services/v3ApiClient';

export type DefaultSampleDataResponse = V3ApiSuccessData<DefaultSampleDetail>;

const useGetDefaultSampleDetails = () => {
  return useQuery<DefaultSampleDataResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: 'accounts/trials/default_sample_details',
      });
      return response.data;
    },
    queryKey: ['defaultSampleDetails'],
  });
};

export default useGetDefaultSampleDetails;
